module.exports = __webpack_public_path__ + "img/1.488e8c37.jpg";